export function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export function formatBytes(bytes) {
  if (bytes == null) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Days until a date; negative if already past. Null if no date. */
export function daysUntil(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return Math.ceil((d.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
}

/**
 * Builds the full UpdateSupplierCommand body from a supplier DTO, applying overrides.
 * The PUT endpoint replaces the whole record, so every field must be sent.
 */
export function toUpdatePayload(supplier, overrides = {}) {
  return {
    id: supplier.id,
    name: supplier.name ?? '',
    legalName: supplier.legalName ?? null,
    tradeName: supplier.tradeName ?? null,
    code: supplier.code ?? null,
    status: supplier.status ?? 'Draft',
    category: supplier.category ?? null,
    tags: supplier.tags ?? [],
    email: supplier.email ?? null,
    phone: supplier.phone ?? null,
    website: supplier.website ?? null,
    description: supplier.description ?? null,
    currency: supplier.currency ?? 'USD',
    taxId: supplier.taxId ?? null,
    registrationNumber: supplier.registrationNumber ?? null,
    paymentTermName: supplier.paymentTermName ?? null,
    paymentTermsDays: supplier.paymentTermsDays ?? null,
    defaultLeadTimeDays: supplier.defaultLeadTimeDays ?? null,
    incoterms: supplier.incoterms ?? null,
    preferredPaymentMethod: supplier.preferredPaymentMethod ?? null,
    minimumOrderValue: supplier.minimumOrderValue ?? null,
    rating: supplier.rating ?? null,
    isPreferred: supplier.isPreferred ?? false,
    prostayAccountingSupplierId: supplier.prostayAccountingSupplierId ?? null,
    tableViewSupplierId: supplier.tableViewSupplierId ?? null,
    ...overrides,
  };
}
